
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-77fe4d66\",\"scoped\":false,\"hasInlineConfig\":true}!../../vue-loader/lib/selector?type=styles&index=0!./NprogressContainer.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./NprogressContainer.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-77fe4d66\"}!../../vue-loader/lib/selector?type=template&index=0!./NprogressContainer.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-nprogress/src/NprogressContainer.vue
// module id = 284
// module chunks = 11